import React, { FC } from 'react';

import { CurrencyCode } from 'app/api/services/site-configs/types';

export type CurrencySymbolProps = {
  currency?: CurrencyCode;
};


export const CURRENCY_SYMBOLS = {
  RUB: '\u20bd',
  KGS: '\u20C0',
  KZT: '\u20B8',
  TJS: '\u20bd',
  UZS: 'so\'m',
};

const CurrencySymbol: FC<CurrencySymbolProps> = ({
  currency,
}) => {
  return (currency && CURRENCY_SYMBOLS.hasOwnProperty(currency))
    ? (
      <span data-test="amount-currency">
        {CURRENCY_SYMBOLS[currency]}
      </span>
    )
    : <>¤</>;
};

export default CurrencySymbol;
